import React from "react";
import check from "../../assets/check.svg";
import redirect from "../../assets/redirect.svg";
import useLocation from "../../utils/Location";
import { getWhatsappLink } from "../../utils/getWhatsappNumber";

const Yearly = ({ currency, plans }) => {
  const { countryCode } = useLocation();
  const whatsappLink = getWhatsappLink(countryCode);

  const getPrice = (plan) => {
    if (currency?.currencyName === "Dirhams") {
      return `AED ${plan.price}`;
    }
    return `${currency?.currencySymbol}${plan.price}.00`;
  };

  return (
    <div id="plan" className="plancontainer">
      {plans?.map((plan, i) => (
        <div
          key={plan.id || i}
          className="planbox"
        >
          <div className="plannamediv">
            <h3 className="planname">{plan.name}</h3>
          </div>

          <h4 className="planprice">
            {getPrice(plan)}
            <span>
              {currency?.currencyName === "Dirhams" ? "+VAT/yearly" : "/yearly"}
            </span>
          </h4>

          <ul>
            {plan.static_features?.map((feature, index) => (
              <li key={index} className="planlist">
                <img src={check} alt="" />
                <p>{feature}</p>
              </li>
            ))}
          </ul>

          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="ctawhatsapp"
          >
            <p className="getstarted">
              Get Started{" "}
              <span>
                <img src={redirect} alt="redirect" />
              </span>
            </p>
          </a>
        </div>
      ))}
    </div>
  );
};

export default Yearly;